import { endpoints } from "./parameters";

function contactRecordToData(record) {
  var data = {};
  data.email = record.get("Email");
  data.firstname = record.get("Firstname");
  data.lastname = record.get("Lastname");
  data.phone = record.get("Phone");
  data.cnum = record.get("NUMContact");
  //cdata.company = record.get("Company");
  return data;
}

export async function getDataFromAirtable(contactNumber, dataHandler) {
  return fetch(
    endpoints.Getcontact + "?cnum=" + contactNumber,

    {
      headers: { accept: "Accept: application/json" },
    }
  )
    .then((response) => {
      if (response && response.ok) {
        return response.json();
      }
    })
    .then((data) => {
      if (data) {
        dataHandler(data);
      }
    });

  /*return contactTable
    .select({
      // Selecting the first record in Grid view, with contact number
      filterByFormula: formula,
    })
    .firstPage()
    .then((records) => {
      if (records) {
        dataHandler(contactRecordToData(records[0]));
      }
    })
    .catch((err) => {
      console.error("Ooops domething happened");
      console.error(err);
    });*/
}
